import styled from 'styled-components';

export default styled.div`
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 20px;
    align-items:center;
`